/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExchangeControl.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/exchange-control";

export class AutogenModelExchangeControl<RowType extends ModelRow> extends Endpoint<RowType, RowExchangeControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExchangeControl extends ModelRow<RowExchangeControlFields> {
	constructor(values?: Partial<RowExchangeControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExchangeControlFields {
	cap_seven_days: string;
	cap_today: string;
	cap_tomorrow: string;
	cap_twenty_eight: string;
	cap_yesterday: string;
	company_id: string;
	contact_method: string;
	contributors: string;
	id: number;
	join_exchange: string;
	participants: string;
	passwd: string;
	publish_when: string;
	scac: string;
	trend_basis: string;
	url: string;
	username: string;
}

